import type { Route } from '~/core/router'

import * as root from '~/routes/tv/root'

export const route: Route = {
  children: [
    {
      path: '',
      component: [root.Title, root.TVPage],
      init: root.model.init,
      left: root.model.left,
    },
  ],
}
